/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IAggiornaPrioritaMultiRequest } from "../shared/interfaces";
import { IProtocolloAreaDiLavoro, ISearchCriteria, IWorkspaceSearchPageResult } from "../shared/interfacesDTO";

const controller = 'AreaDiLavoro';



const getProtocolliAreaDiLavoro = (uorId: number, searchCriteria: ISearchCriteria, cancelToken?: CancelToken ): Promise<IWorkspaceSearchPageResult> => {
    return axiosInstance.post(`${controller}/GetProtocolliAreaDiLavoro/${uorId}`, searchCriteria, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}
const getProtocolloAreaDiLavoro = (uorId: number, protocolId, cancelToken?: CancelToken): Promise<IProtocolloAreaDiLavoro> => {
    return axiosInstance.get(`${controller}/GetProtocolloAreaDiLavoro/${uorId}/${protocolId}`, { cancelToken: cancelToken })
        .then(result => {
            if (result.status === 204) {
                return undefined;
            }
            return result.data
        })
        .catch(error => {
            return Promise.reject(error);
        });
}



const addProtocolloAreaDiLavoro = (uorId: number, protocolId: number, cancelToken?: CancelToken): Promise<IProtocolloAreaDiLavoro> => {
    return axiosInstance.post(`${controller}/Add/${uorId}/${protocolId}`, undefined, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const avviaLavorazione = (uorId: number, areaDiLavoroId: number, cancelToken?: CancelToken): Promise<void> => {
    return axiosInstance.put(`${controller}/AvviaLavorazione/${uorId}/${areaDiLavoroId}`, undefined, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const avviaLavorazioneEPrendiInCaricoMulti = (uorId: number, idItemsAreaDiLavoro: number[], cancelToken?: CancelToken): Promise<void> => {
    return axiosInstance.put(`${controller}/AvviaLavorazioneEPrendiInCaricoMulti/${uorId}`, idItemsAreaDiLavoro, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const aggiornaPrioritaMulti = (uorId: number, request: IAggiornaPrioritaMultiRequest, cancelToken?: CancelToken): Promise<void> => {
    return axiosInstance.put(`${controller}/AggiornaPrioritaMulti/${uorId}`, request, { cancelToken: cancelToken,  })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const pendiInCaricoMulti = (uorId: number,  idItemsAreaDiLavoro: number[], cancelToken?: CancelToken): Promise<void> => {
    return axiosInstance.put(`${controller}/PendiInCaricoMulti/${uorId}`, idItemsAreaDiLavoro, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const terminaLavorazioneMulti = (uorId: number, idItemsAreaDiLavoro: number[], cancelToken?: CancelToken): Promise<void> => {
    return axiosInstance.put(`${controller}/TerminaLavorazioneMulti/${uorId}`, idItemsAreaDiLavoro, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const ripristinaLavorazione = (uorId: number, areaDiLavoroId: number, cancelToken?: CancelToken): Promise<void> => {
    return axiosInstance.put(`${controller}/RipristinaLavorazione/${uorId}/${areaDiLavoroId}`, undefined, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getProtocolliAreaDiLavoro,
    getProtocolloAreaDiLavoro,
    addProtocolloAreaDiLavoro,
    avviaLavorazione,
    avviaLavorazioneEPrendiInCaricoMulti,
    aggiornaPrioritaMulti,
    pendiInCaricoMulti,
    terminaLavorazioneMulti,
    ripristinaLavorazione
}